<template>
  <div>
    <bread :data="bread" />

    <el-form size="mini" :inline="true">
      <el-form-item label="部门">
        <el-select v-model="searchData.officeName" placeholder="请选择部门">
          <el-option v-for="item in options" :key="item.id" :label="item.label" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="服务人员姓名">
        <el-input v-model="searchData.servicePerson" placeholder="请输入服务人员姓名"></el-input>
      </el-form-item>
      <el-form-item label="服务态度">
        <el-select v-model="searchData.serviceAttitude" placeholder="请选择服务态度">
          <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="服务效率">
        <el-select v-model="searchData.serviceEfficiency" placeholder="请选择服务效率">
          <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="服务质量">
        <el-select v-model="searchData.serviceQuality" placeholder="请选择服务质量">
          <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="廉政情况">
        <el-select v-model="searchData.incorruptible" placeholder="请选择廉政情况">
          <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="init()">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="success" @click="feedbackExport()">导出</el-button>
      </el-form-item>
    </el-form>

    <cesTable
      size="mini"
      :isSelection="false"
      :isIndex="true"
      :isPagination="true"
      :loading="false"
      :isHandle="true"
      :tableData="tableData"
      :tableCols="tableCols"
      :tableHandles="tableHandles"
      :pagination="pagination"
      @refresh="init"
    />

    <feedbackInfo ref="feedbackInfo" :title="title" />
  </div>
</template>
    <!-- 用户反馈管理 -->
<script>
import bread from "@/components/Module/Bread";
import cesTable from "@/components/Module/Table";
import feedbackInfo from "./FeedbackInfo";

import {
  feedbackListApi,
  feedOfficeListApi,
  feedbackDelApi,
  feedbackExportApi
} from "@/api/api";

export default {
  name: "",
  data() {
    return {
      bread: [
        {
          link: "",
          name: "首页"
        },
        {
          link: "",
          name: "廉政评价管理"
        },
        {
          link: "",
          name: "用户反馈管理"
        }
      ],
      searchData: {
        officeName: "",
        servicePerson: "",
        serviceAttitude:"",
        serviceEfficiency:"",
        serviceQuality:"",
        incorruptible:""
      },
      options:[],
      options2:[
          {
              label:"是",
              value:"0"
          },
          {
              label:"否",
              value:"1"
          }
      ],
      tableData: [],
      tableCols: [
        { label: "联系人", prop: "name" },
        { label: "联系电话", prop: "phone" },
        { label: "部门", prop: "officeName" },
        { label: "服务人员名称", prop: "servicePerson" },
        { label: "服务事项", prop: "serviceMatter" },
        { label: "服务态度：工作是否主动积极，是否专业，是否热情。", prop: "serviceAttitude" ,formatter: row => this.format(row.serviceAttitude)},
        { label: "服务效率：是否在约定时间内完成工作。", prop: "serviceEfficiency" ,formatter: row => this.format(row.serviceEfficiency) },
        { label: "服务质量：完成的工作是否合格。", prop: "serviceQuality" ,formatter: row => this.format(row.serviceQuality) },
        { label: "廉政情况：是否有吃拿卡要现象。", prop: "incorruptible" ,formatter: row => this.format(row.incorruptible) },
        { label: "反馈内容", prop: "content" },
        {label: "反馈时间", prop: "createDate"},
        {label: "微信昵称", prop: "wxName"},
        {label: "综合评价", prop: "evaluation"},
        {
          label: "操作",
          type: "Button",
          btnList: [
            {
              type: "danger",
              label: "删除",
              handle: (row, i) => this.del(row, i)
            }
          ]
        }
      ],
      tableHandles: [
        // { label: "新增", type: "primary", handle: row => this.add() }
      ],
      pagination: {
        pageSize: 15,
        pageNum: 1,
        total: 0
      },
      title: ""
    };
  },
  methods: {
    async info(v, i) {
      this.title = "用户反馈详情";
      this.$refs.feedbackInfo.init(v);
    },
    format(val) {
      switch (val) {
                case "0":
                  return "是";
                  break;
                case "1":
                  return "否";
                  break;
              }
    },
    init() {
      let {
        pagination: { pageSize, pageNum },
        searchData: { officeName = "",
        servicePerson = "",
        serviceAttitude = "",
        serviceEfficiency = "",
        serviceQuality = "",
        incorruptible = "" }
      } = this;
      feedbackListApi({
        officeName: officeName,
        servicePerson: servicePerson,
        serviceAttitude:serviceAttitude,
        serviceEfficiency:serviceEfficiency,
        serviceQuality:serviceQuality,
        incorruptible:incorruptible,
        "page.current": pageNum,
        "page.pageSize": pageSize
      })
        .then(res => {
          this.tableData = res.list;
          this.pagination.total = parseInt(res.total);
        })
        .catch(err => {
          console.log(err);
        });
    },
    getOfficeList() {
      feedOfficeListApi('office').then(res => {
        this.options = res;
      });
    },
    del(v, i) {
      let { id } = v;
      let { init } = this;
      elMsgBox("您确定要删除这条数据吗？", "del").then(res => {
        feedbackDelApi(id).then(res => {
          elMsg("删除成功");
          init();
        });
      });
    },
    feedbackExport() {
      feedbackExportApi().then(res => {
        downloadFile(res.data,"用户反馈表.xlsx")
        elMsg("导出成功");
      })
    }
  },
  created() {
    this.init();
    this.getOfficeList();
  },
  components: {
    bread,
    cesTable,
    feedbackInfo
  }
};
</script>

<style lang='less' scoped>
</style>